<po-page-default p-title="Arquivos de Certidões Disponíveis" [p-breadcrumb]="breadcrumb">
  <div class="certidoes-page-actions">
    <div class="certidoes-page-actions-left">
      <po-button
        p-label="Relatório"
        p-icon="an an-file-arrow-down"
        (p-click)="irRelatorio()">
      </po-button>
      <po-button
        p-label="Atualizar"
        p-icon="an an-arrows-clockwise"
        [p-loading]="loadingTable"
        [p-disabled]="loadingTable || loadingShowMore"
        (p-click)="atualizarTabela()">
      </po-button>
    </div>
  </div>

  <po-table
    p-container="border"
    class="certidoes-table"
    p-striped="true"
    p-text-wrap="true"
    p-hide-columns-manager="true"
    [p-loading]="loadingTable"
    [p-columns]="columns"
    [p-items]="tableItems"
    [p-actions]="tableActions"
    (p-show-more)="carregarMais()"
    [p-show-more-disabled]="!moreItens"
    [p-loading-show-more]="loadingShowMore">
  </po-table>
</po-page-default>
